import { Loading } from 'react-style-guide';
import React, { useState, useEffect } from 'react';
import { WithTranslationsProps, withTranslations } from 'react-utilities';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import SortDetailGrid from './SortDetailGrid';
import { TSort } from '../common/types/bedev1Types';
import { CommonGameSorts } from '../common/constants/translationConstants';
import cacheServices from '../common/services/cacheServices';
import ErrorStatus from '../common/components/ErrorStatus';
import gameCarouselTranslationConfig from '../../../js/react/gameCarousel/translation.config';

export const SortDetail = ({
  match,
  translate
}: RouteComponentProps<{ sortName: string }> & WithTranslationsProps): JSX.Element => {
  const sortName = decodeURIComponent(match.params.sortName);
  const [sort, setSort] = useState<TSort | undefined>(undefined);
  const [redirect, setRedirect] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const fetchSort = async () => {
    setError(false);
    setSort(undefined);
    try {
      const { sorts } = await cacheServices.getGameSorts();
      const selectedSort = sorts.find(sortItem => sortItem.name === sortName);
      if (selectedSort === undefined) {
        setRedirect(true);
      } else {
        setSort(selectedSort);
      }
    } catch {
      setError(true);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-void
    void fetchSort();
  }, [sortName]);

  // Error in API calls
  if (error) {
    return (
      <div className='game-sort-detail-container'>
        <h1>{translate(CommonGameSorts.LabelGames)}</h1>
        <div className='game-sort-detail'>
          <ErrorStatus
            errorMessage={translate(CommonGameSorts.LabelApiError)}
            onRefresh={fetchSort}
          />
        </div>
      </div>
    );
  }

  // Redirect if sort cannot be found
  if (redirect) {
    return <Redirect to='/' />;
  }

  // Sort Details are loaded
  if (sort) {
    return (
      <div className='game-sort-detail-container'>
        <h1>{sort.displayName}</h1>
        <SortDetailGrid sort={sort} translate={translate} />
      </div>
    );
  }

  return <Loading />;
};

export default withTranslations(SortDetail, gameCarouselTranslationConfig);
